import { getAllDistricts } from "@/api";

const districtModule = {
    namespaced: true,
    state: {
        createDistrict: false,
        createFormState: false,
        districts: []
    },
    getters: {
        createDistrict: state => state.createDistrict,
    },
    actions: {
        sendCreationEvent({ commit }, data) {
            commit('setCreateDistrict', data);
        },
        closeForm({ commit }) {
            commit('closeForm');
        },
        async getAllDistricts({ commit }, bounds) {
            let params = { bounds: bounds };
            await getAllDistricts(params).then(response => {    
                let districts = response.data.map(district => {
                    return {
                        ...district,
                        opacity: 0.3,
                        polygon: district.polygon.coordinates[0].map((elem) => {
                            return [elem[1], elem[0]]
                        }),
                    }
                })
                commit('setDistricts', districts);
            })
            .catch(error => { 
                console.error(error);
            })
        },
        makesTheArrayOfDistrictsEmpty({ commit }) {
            commit('setEmptyArrayToDistricts');
        }
    },
    mutations: {
        setCreateDistrict(state, data) {
            state.createDistrict = data;
            state.createFormState = data;
        },
        closeForm(state) {
            state.createDistrict = false;
            state.createFormState = false;
        },
        setDistricts(state, districts) {
            state.districts = districts;
        },
        setEmptyArrayToDistricts(state) {
            state.districts = [];
        }
    },
};

export default districtModule;